import { render, staticRenderFns } from "./receiptInspection.vue?vue&type=template&id=bbc7449a&scoped=true"
import script from "./receiptInspection.vue?vue&type=script&lang=js"
export * from "./receiptInspection.vue?vue&type=script&lang=js"
import style0 from "./receiptInspection.vue?vue&type=style&index=0&id=bbc7449a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc7449a",
  null
  
)

export default component.exports